/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Theme_LightInputs */

const en_us2_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const pt_br2_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

const es_419_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

const pt_pt2_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

const fr_fr2_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clair`)
};

const de_de2_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hell`)
};

const it_it2_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiaro`)
};

/**
* | output |
* | --- |
* | "Light" |
*
* @param {Profile_Theme_LightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_theme_light = /** @type {((inputs?: Profile_Theme_LightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Theme_LightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_theme_light(inputs)
	if (locale === "es-419") return es_419_profile_theme_light(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_theme_light(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_theme_light(inputs)
	if (locale === "de-DE") return de_de2_profile_theme_light(inputs)
	if (locale === "it-IT") return it_it2_profile_theme_light(inputs)
	return en_us2_profile_theme_light(inputs)
});
export { profile_theme_light as "profile.theme_light" }